import React from "react";

/**
 * Tiny gold pill shown next to a founding member's name.
 * Renders nothing when `active` is false.
 *
 * Sizes:
 *   - sm  (default): inline next to names, 10px label-ui
 *   - md           : 12px, more presence (e.g. book cover credits)
 */
export const FoundingBadge = ({ active = false, size = "sm", className = "" }) => {
  if (!active) return null;
  const isMd = size === "md";
  return (
    <span
      data-testid="founding-badge"
      className={`inline-flex items-center gap-1 align-middle ${className}`}
      style={{
        background: "linear-gradient(180deg, #D4B057 0%, #B8973A 60%, #957729 100%)",
        color: "#FAF7F2",
        padding: isMd ? "4px 10px" : "2px 7px",
        borderRadius: 999,
        fontFamily: "Inter, system-ui, sans-serif",
        fontSize: isMd ? 11 : 9,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 600,
        boxShadow: "0 1px 0 rgba(255,255,255,0.25) inset, 0 1px 2px rgba(0,0,0,0.15)",
        whiteSpace: "nowrap",
        lineHeight: 1,
      }}
      title="Founding Member — locked-in pricing forever"
    >
      <span aria-hidden style={{ fontSize: isMd ? 10 : 8, marginTop: -1 }}>✦</span>
      Founding Member
    </span>
  );
};

export default FoundingBadge;
